import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import update from "immutability-helper";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AWS from "aws-sdk";
import IconButton from "@mui/material/IconButton";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { Combobox } from "@headlessui/react";
import ClearIcon from "@mui/icons-material/Clear";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import FlavorTabShimmer from "./FlavorTabShimmer";
import { ServiceApi } from "../services/index.service";
import FavouritesList from "../components/FavouritesList";
import { useSnackbar } from "notistack";
import {
  Alert,
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  InputAdornment,
  OutlinedInput,
  TextareaAutosize,
} from "@mui/material";
import { setUserStores, storeSet } from "../redux/store/storeSlice";
import StoreOptionsGrid from "./StoreOptionsGrid";
import FlavorCategoryItems from "./FlavorCategoryItems";
import { FLAVOR_DRIVEN_TREATS, TEST_INTRITASSTOREID } from "../utils/constants";
import { StoreDropdown } from "./shared/StoreDropdown";
//Tour Imports
import { runTour, showTourProgress, updateSteps, continuousTour } from "../redux/userOnboarding/userOnboardingSlice";
import { FLAVOR_PORTAL_TOUR_STEPS } from "../utils/tourConstants";
import moment from "moment/moment";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export const getSignedUrl = (file) => {
  // const fileData=file.replace("'","")
  return file;
};

export const getSearchResults = (data = [], searchKey = '', dataKey = 'flavors') => {
  let result = JSON.parse(JSON.stringify(data));
  if (dataKey === 'flavors')
    result = result.map(obj => ({ ...obj, [dataKey]: obj[dataKey]?.filter(f => (f.flavor_name)?.toLowerCase().includes(searchKey.toLowerCase())) }));
  else
    result = result.map(obj => ({ ...obj, [dataKey]: obj[dataKey]?.map(flv => ({ ...flv, list: flv.list?.filter(f => (f.flavor_name)?.toLowerCase().includes(searchKey.toLowerCase())) })) }));
  return result;
}
const initialConflictItem={
  show:false,
  message:""
}

// Frozen Lemonades Flavor Ids
export const lemonadeId = 507;
export const mangoLemonadeId = 523;
export const strawberryLemonadeId = 99;
export const topFrozenRecords = [lemonadeId, mangoLemonadeId, strawberryLemonadeId];
export const lemonadesProductId = 116;
export const sortFrozenRecords = (records) => {
  return records.sort((a, b) => {
    if (topFrozenRecords.includes(a.intFlavorID) && !topFrozenRecords.includes(b.intFlavorID)) {
      return -1;
    }
    if (!topFrozenRecords.includes(a.intFlavorID) && topFrozenRecords.includes(b.intFlavorID)) {
      return 1;
    }
    return a.flavor_name.localeCompare(b.flavor_name);
  });
};

const FlavorsList = ({ catering = false }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const serviceapi = new ServiceApi();
  const { storage, userOnboarding } = useSelector((state) => state);
  const data = useSelector((state) => state);
  // handle flavors
  const [loading, setLoading] = React.useState(false);
  const [flavorLoading, setFlavorLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [flavors, setFlavors] = React.useState(null);
  const [flavorSearch, setFlavorSearch] = useState("");
  const [storeOptions, setStoreOptions] = useState(null);
  const [storeOptionsArray, setStoreOptionsArray] = useState([]);
  const [tempFlavors, setTempFlavors] = useState(null);
  const [fcuser, setFCUser] = useState(null);
  const [FCUserList, setFCUserList] = useState([]);
  const [queryFC, setQueryFC] = useState("");
  const [conflictItem, setConflictItem] = useState(initialConflictItem);
  // handle stores
  const [store, setStore] = useState(null);
  const [storeList, setStoreList] = useState([]);
  // handle resolve
  let isFCUAPIResolved = false;
  let isFCUSAPIResolved = false;
  const s3 = new AWS.S3();
  // handle tabs
  let tabIndex = 0;
  if(!userOnboarding?.tourStatus?.flavorPortal) {
    tabIndex = 2;
  }
  const [tab, setTab] = useState(tabIndex);
  const [tabSlcted, setTabSlcted] = useState("");

  const [open, setOpen] = React.useState(false);
  const [coolAlert, setCoolAlert] = React.useState(false);
  const [coolAlertCustomMessage, setCoolAlertCustomMessage] = React.useState("");
  const [openDialog, setOpenDialog] = React.useState(false);
  const [clearAll, setClearAll] = React.useState(false);
  const [tCount, setTCount] = useState(4);
  const [isDirty, setIsDirty] = useState(false);
  const [editStoreAccess, setEditStoreAccess] = useState(true);
  const FCAccessRoles = ["Super Admin", "Admin", "Director(FC Lead)"];
  const StoreAccessRoles = ["Manager", "Treat Team"];
  const [seconds, setSeconds] = useState(0);

  const handleClose = () => {
    setOpen(false);
  };
  const handleCoolAlert = () => {
    setCoolAlert(!coolAlert);
    setCoolAlertCustomMessage("")
  };
  const handleConfirmDialog = () => {
    setOpenDialog(!openDialog);
  };
  const handleRefreshFlavors =async () => {
    setConflictItem(initialConflictItem);
    await getFlavors();
  };
  const handleOK = () => {
    setTab(tabSlcted);
    setOpen(false);
  };

  useEffect(() => {
    isFCUAPIResolved = false;
    isFCUSAPIResolved = false;
    if(data?.profile){
      setLoading(true);
      getFCusers();
      getFCUserStores("all");
      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.profile?.user_name]);

  const startFlavorPortalTour = () => {
    const filteredSteps = FLAVOR_PORTAL_TOUR_STEPS.filter(step => step.key ? storeOptions?.[step.key] : true );
    dispatch(updateSteps(filteredSteps));
    dispatch(continuousTour());
    dispatch(showTourProgress());
    dispatch(runTour("flavorPortal"));
  }

  useEffect(() => {
    if (store) {
      getFlavors();
    }
  }, [store]);
  useEffect(() => {
    if (storage?.store) {
      setStore(storage?.store)
    }
  }, [storage?.store]);

  //Tour Hook 
  useEffect( () => {
    if (!userOnboarding?.tourStatus?.flavorPortal && flavors?.all_flavors?.length > 0){
       startFlavorPortalTour();
    }
  }, [flavors, userOnboarding?.tourStatus?.flavorPortal])

  useEffect(() => {
    let interval
    if(submitLoading){
      interval = setInterval(
        () => setSeconds((prev)=>prev+1),
        1000,
    );
  }else{
    setSeconds(0)
  }
  return () => clearInterval(interval);
  }, [submitLoading])


  const getFCusers = async () => {
    const req = {
      role: data?.profile?.role,
      uid: data?.profile?.uid,
      user_name: data?.profile?.user_name,
    };
    const response = await serviceapi.fetchFCUserList(req);
    if (response) {
      setFCUserList(response);

      if (FCAccessRoles.indexOf(data?.profile?.role) === -1) {
        setFCUser(response[0]);
      }

      isFCUAPIResolved = true;
      setTimeout(() => {
        if (isFCUSAPIResolved === true) {
          setLoading(false);
        }
        let storeExists = storage?.store && Object.keys(storage?.store).length
          ? storage?.store
          : store
          ? store
          : "";
        if (storeExists) {
          const FSMUserIndex = response?.findIndex(
            (item) => item.fsm_name === storeExists?.FSMName
          );

          setFCUser(response[FSMUserIndex]);
        }
      }, 1500);
    }
  };

  const handleStoreChange = (event) => {
    setStore(event);
    const FSMUserIndex = FCUserList?.findIndex(
      (item) => item.fsm_name === event.FSMName
    );

    setFCUser(FCUserList[FSMUserIndex]);
    dispatch(storeSet(event));
  };

  const getFCUserStores = async (fcname) => {
    const req = {
      role: data?.profile?.role,
      uid: data?.profile?.contact_id,
      user_name: data?.profile?.user_name,
      fsm_name: fcname,
    };
    const response = await serviceapi.fetchFCStores(req);
    setStoreList(response);
    dispatch(setUserStores(response));
    if (response) {
      isFCUSAPIResolved = true;
      if(response?.length ===0){
        setTempFlavors([]);
        setFlavors([]);
        setTab(0)
        setIsDirty(false);
      }
      if (fcname !== "all") {
        dispatch(storeSet(response?.[0] || null));
        setStoreList(response);
        setStore(response?.[0] || null);
      }
      setTimeout(() => {
        if (FCAccessRoles.indexOf(data?.profile?.role) === -1) {
          setStore(response?.[0] || null);
        }

        if (StoreAccessRoles.indexOf(data?.profile?.role) !== -1) {
          setEditStoreAccess(false);
        }
        if (isFCUAPIResolved === true) {
          if (storage?.store && Object.keys(storage?.store).length > 0) {
            setStore(storage?.store);
          }
          setLoading(false);
        }
      }, 1500);
    }
  };

  const handleFCUserChange = (event) => {
    getFCUserStores(event?.fsm_name);
    setFCUser(event);
    setFlavorSearch("");
  };

  const filteredFCUsers =
    queryFC === ""
      ? FCUserList
      : FCUserList.filter((fcUser) => {
          let userString = `${fcUser.fsm_name} - ${fcUser.fsm}`;
          return userString?.toLowerCase()?.includes(queryFC?.toLowerCase());
        });

  const getFlavors = async () => {
    setFlavorLoading(true);
    const allFlavorsReq = {
      keyword: "",
      activeFlag: true,
      api_version: 2
    };
    const allFlavorsResponse = await serviceapi?.fetchManageFlavors(allFlavorsReq);
    const req = {
      intStoreID: store?.intStoreID,
      filter: "all",
      api_version: 2
    };
    let response;
    if (catering)
      response = await serviceapi?.fetchCateringFlavors(store?.intStoreID, req);
    else
      response = await serviceapi?.fetchStoreFlavors(req);
    
    if (response?.available_flavors?.length > 0) {
      const mappedFlavorsData = response?.available_flavors?.filter(category => category?.active)?.map((category) => {
        const product = allFlavorsResponse?.find(c => c.intProductTypeID === category?.intProductTypeID) || { ...category, flavors: [] };
        return ({
          ...product,
          flavors: product?.flavors?.map(flavor => {
            const active_flavor = response?.active_flavors?.find(f => (f.intProductTypeID === flavor?.intProductTypeID && f.intFlavorID === flavor?.intFlavorID));
            const isFavorite = response?.favourite_flavors?.find(f => (f.intProductTypeID === flavor?.intProductTypeID && f.intFlavorID === flavor?.intFlavorID));
            return ({
              ...flavor,
              dmb: active_flavor?.dmb || false,
              web: active_flavor?.web || false,
              dt: active_flavor?.dt || false,
              oo: active_flavor?.oo || false,
              ct: active_flavor?.ct || false,
              favourite: isFavorite ? true : false,
              active_rank: active_flavor ? 1 : 0
            })
          })
        })
      });
      
      console.log('mappedFlavorsData ', mappedFlavorsData);
      setTempFlavors({ ...response, all_flavors: mappedFlavorsData });
      splitDataObject({ ...response, all_flavors: mappedFlavorsData });
      setIsDirty(false);
    }
      else if(response?.all_flavors?.length > 0){
        setTempFlavors(response);
        splitDataObject(response);
        setIsDirty(false);
      }else{
        setFlavors(null);
        setFlavorLoading(false);
      }

  };

  const generateGroups = (allFlavors) => {
    allFlavors?.map((item, index) => {
      if (item?.flavors?.length <= 6) {
        const newGrp = createGroups(item?.flavors, 1);
        item.newFlavorsList = newGrp;
      } else if (item?.flavors?.length > 6 && item?.flavors?.length <= 12) {
        const newGrp = createGroups(item?.flavors, 2);
        item.newFlavorsList = newGrp;
      } else {
        const newGrp = createGroups(item?.flavors, 3);
        item.newFlavorsList = newGrp;
      }
    });
    return allFlavors;
  }

  const splitDataObject = (response) => {
    if (response) {
      const storeOptionItems = response?.store_options;
      setStoreOptions(storeOptionItems);
      const arrayItems = Object.keys(storeOptionItems)
        .map((i) => {
          return { name: i, value: storeOptionItems[i] };
        })
        .filter((j) => j.value === true);
      setStoreOptionsArray(arrayItems);
      response.all_flavors = generateGroups(response?.all_flavors);
      setTCount(
        Object.values(response?.store_options).reduce(
          (a, item) => a + (item === true ? 1 : 0),
          0
        )
      );
    }

    setFlavors(response);

    setFlavorLoading(false);
  };

  const updateFlavors = async (last_updated_date) => {
    if (!store.intStoreID) {
      enqueueSnackbar("Please select a store!", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "warning",
      });
      return;
    }
    const data = flavors.all_flavors?.filter((category) => {
      const activeFlavorIds = flavors.active_flavors?.filter(f => (f?.intProductTypeID === category?.intProductTypeID && f?.web))?.map(f => f?.intFlavorID);
      const check = category?.flavors?.some((i) => i?.web === true && !activeFlavorIds.includes(i?.intFlavorID));
      return check;
    });
    // CoolAlerts Modal should be show once a day after 03:00 am
    const threeAmToday = moment().startOf('day').add(3, 'hours');
    const isNotUpdatedToday = (moment(last_updated_date).isBefore(threeAmToday));
    const isWebEnabledAlready = flavors.active_flavors?.some(f => (f?.web));
    if ((isNotUpdatedToday && isWebEnabledAlready) || data?.length > 0) {
      setCoolAlert(true);
    } else {
      handleSubmit();
    }
  };

  const isOOUpdated = (prevActiveOOFlavors, currActiveOOFlavors) => {
    if(prevActiveOOFlavors?.length !== currActiveOOFlavors?.length) {
      return true;
    }
    const prevActiveOOFlavorsIds = prevActiveOOFlavors.map(flv => `${flv.intProductTypeID}-${flv.intFlavorID}`).sort();
    const currActiveOOFlavorsIds = currActiveOOFlavors.map(flv => `${flv.intProductTypeID}-${flv.intFlavorID}`).sort();
    return !prevActiveOOFlavorsIds.every((id, index) => id === currActiveOOFlavorsIds[index]);
  }

  const handleSubmit = async (coolalert = false, isConfirmed) => {
    try {
      const prevActiveOOFlavors = flavors?.active_flavors?.filter(i => i?.oo);
      const currActiveOOFlavors = [];
      const activeFlavors = flavors.all_flavors?.reduce((acc, category) => {
        const flavors = category?.flavors?.filter((i) => (i?.web || i?.dmb || i?.dt || (i?.oo || prevActiveOOFlavors.find(f => (f.intFlavorID == i?.intFlavorID && f.intProductTypeID == i?.intProductTypeID))) || i?.ct)) || [];
        currActiveOOFlavors.push(...category?.flavors?.filter(i => i?.oo));
        return [...acc, ...flavors];
      }, []);
      if (!activeFlavors.some(flv => (flv?.web || flv?.dmb || flv?.dt || flv?.oo || flv?.ct)) && !isConfirmed) {
        setOpenDialog(true);
        return;
      }
      setSubmitLoading(true);
      //Set The Payload for updating flavors
      const activeFlavorsPayload = activeFlavors.map(flv => {
        const activeFlvPayload = {};
        //components attribute below is specifically for Flavor Driven Treats, currently not using (Dec1,2023)
        let attrs = ['intFlavorID', 'fid', 'intProductTypeID', 'web', 'dmb', 'dt', 'oo', 'ct', 'receiptName',
                     'flavor_name', 'product_type_name', 'components']
        attrs.forEach(attr => activeFlvPayload[attr] = flv[attr]);
        return activeFlvPayload;
      });
      const req = {
        store: {
          intRitasStoreID: store?.intRitasStoreID,
          intStoreID: store.intStoreID,
          vchStoreName: store?.vchStoreName,
          vchStoreState: store?.vchStoreState,
        },
        last_updated_date:flavors?.last_updated_date,
        active_flavors: activeFlavorsPayload,
        isOOUpdated: isOOUpdated(prevActiveOOFlavors, currActiveOOFlavors),
        store_user: data?.profile?.preferred_username,
        user_agent: navigator.userAgent
      };

      let responseData;
      if (catering)
        responseData = await serviceapi.updateCateringFlavors(req);
      else
        responseData = await serviceapi.updateFlavors(req);

        console.log('responseData ', responseData);
      if (responseData?.success) {
        setIsDirty(false);
        setClearAll(false);
        setOpenDialog(false);
        setCoolAlert(false);
        setCoolAlertCustomMessage("")
        await getFlavors();
        const response = responseData?.data;
        if (response?.store_resp && response?.store_resp?.statusCode) {
          if (response?.store_resp && response?.store_resp?.statusCode === 200) {
            enqueueSnackbar("Flavors update to store is successfully", {
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "success",
            });
            setSubmitLoading(false);
            if(coolalert){
              const coolAlertReq={
                intRitasStoreID: store?.intRitasStoreID,
                intStoreID: store.intStoreID,
                vchCustomMsg:coolAlertCustomMessage
              }
              const coolAlertResponse =  serviceapi.sendCoolAlerts(coolAlertReq);
              console.log(coolAlertResponse)
            }
          } else {
            enqueueSnackbar("Flavors update to store has failed. Please re-try", {
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "error",
            });
            setSubmitLoading(false);
          }
        }
        if (response?.vendor_resp !== "" && storeOptions?.oo) {
          if (response?.vendor_resp?.statusCode === 200) {
            enqueueSnackbar("Flavors update to online ordering is successfully", {
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
              variant: "success",
            });
            setSubmitLoading(false);
          } else {
            enqueueSnackbar(
              "Flavors update to online ordering has failed. Please re-try.",
              {
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "right",
                },
                variant: "error",
              }
            );
            setSubmitLoading(false);
          }
        }
        setSubmitLoading(false);
      }else if(!responseData?.success && responseData?.statusCode===200){
        setSubmitLoading(false);
        setIsDirty(false);
        setClearAll(false);
        setOpenDialog(false);
        setCoolAlert(false);
        setCoolAlertCustomMessage("")
        setConflictItem({
          show:true,
          // message:"A team member has updated flavors. Refreshing the screen to display the most updated data."
          message:responseData?.message
        })
      }else{
        setIsDirty(false);
        setClearAll(false);
        setOpenDialog(false);
        setCoolAlert(false);
        setCoolAlertCustomMessage("")
        enqueueSnackbar("Something went wrong, please try again!", {
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        });
        setSubmitLoading(false);
      }
    } catch (e) {
      setIsDirty(false);
      setClearAll(false);
      setOpenDialog(false);
      setCoolAlert(false);
      setCoolAlertCustomMessage("")
      enqueueSnackbar("Something went wrong, please try again!", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
      setSubmitLoading(false);
    }
  };

  const handleSellerCheckFromChild = (
    event,
    categoryIndex,
    flavorId,
    seller,
    fid
  ) => {
    let foundIndex = -1;
    let foundItemId = null;
    console.log(categoryIndex,
      flavorId,
      seller)
    const flavorIndex = flavors?.all_flavors[categoryIndex].flavors.findIndex(
      (f) => f.intFlavorID === flavorId
    );
    console.log(flavorIndex)

    const mangoFlavorIndex = flavors?.all_flavors[categoryIndex].flavors.findIndex(
      (f) => f.intFlavorID === mangoLemonadeId
    );
    const strawberryFlavorIndex = flavors?.all_flavors[categoryIndex].flavors.findIndex(
      (f) => f.intFlavorID === strawberryLemonadeId
    );
    const isLemonade = (lemonadesProductId === flavors?.all_flavors[categoryIndex]?.intProductTypeID) && flavorId === lemonadeId;
    let mangoIndex = null;
    let strawberryIndex = null;


    flavors?.all_flavors[categoryIndex].newFlavorsList.map(
      (listItem, index) => {
        const itemIndex = listItem.list.findIndex(
          (item) => item.intFlavorID === flavorId
        );

        if (itemIndex !== -1) {
          foundIndex = index;
          foundItemId = itemIndex;
        }

        if (isLemonade) {
          mangoIndex = listItem.list.findIndex(
            (item) => item.intFlavorID === mangoLemonadeId
          );
          strawberryIndex = listItem.list.findIndex(
            (item) => item.intFlavorID === strawberryLemonadeId
          );
        }
      }
    );

    const newData = update(flavors, (isLemonade && ['dmb', 'dt'].includes(seller)) ? {
      all_flavors: {
        [categoryIndex]: {
          flavors: {
            [flavorIndex]: {
              [seller]: { $set: event.target.checked },
              updated_date: new Date()
            },
            [mangoFlavorIndex]: { [seller]: { $set: event.target.checked }, updated_date: new Date() },
            [strawberryFlavorIndex]: { [seller]: { $set: event.target.checked }, updated_date: new Date() },
          },
          newFlavorsList: {
            [foundIndex]: {
              list: {
                [foundItemId]: { [seller]: { $set: event.target.checked } },
                [mangoIndex]: { [seller]: { $set: event.target.checked } },
                [strawberryIndex]: { [seller]: { $set: event.target.checked } },
              },
            },
          },
        },
      },
    } : {
      all_flavors: {
        [categoryIndex]: {
          flavors: {
            [flavorIndex]: { [seller]: { $set: event.target.checked}, updated_date: new Date() },
          },
          newFlavorsList: {
            [foundIndex]: {
              list: {
                [foundItemId]: { [seller]: { $set: event.target.checked } },
              },
            },
          },
        },
      },
    });
    setFlavors(newData);
    if (seller === 'favourite') {
      const req = {
        intStoreID: store?.intStoreID,
        fid,
        intProductTypeID: flavors?.all_flavors[categoryIndex]?.intProductTypeID,
        intFlavorID: flavorId,
        isFavourite: event.target.checked
      };
      updateFavourite(req, newData);
    }
    else {
      setIsDirty(true);
    }
  };

  // handle seller check
  const handleSellerCheck = (
    event,
    categoryIndex,
    subCategoryIndex,
    flavorId,
    seller,
    fid
  ) => {
    let foundIndex = -1;
    let foundItemId = null;
    const flavorIndex = flavors?.all_flavors[categoryIndex].flavors.findIndex(
      (f) => f.intFlavorID === flavorId
    );

    const mangoFlavorIndex = flavors?.all_flavors[categoryIndex].flavors.findIndex(
      (f) => f.intFlavorID === mangoLemonadeId
    );
    const strawberryFlavorIndex = flavors?.all_flavors[categoryIndex].flavors.findIndex(
      (f) => f.intFlavorID === strawberryLemonadeId
    );
    const isLemonade = (lemonadesProductId === flavors?.all_flavors[categoryIndex]?.intProductTypeID) && flavorId === lemonadeId;
    let mangoIndex = null;
    let strawberryIndex = null;

    flavors?.all_flavors[categoryIndex].newFlavorsList.map(
      (listItem, index) => {
        const itemIndex = listItem.list.findIndex(
          (item) => item.intFlavorID === flavorId
        );
        if (itemIndex !== -1) {
          foundIndex = index;
          foundItemId = itemIndex;

          if (isLemonade) {
            mangoIndex = listItem.list.findIndex(
              (item) => item.intFlavorID === mangoLemonadeId
            );
            strawberryIndex = listItem.list.findIndex(
              (item) => item.intFlavorID === strawberryLemonadeId
            );
          }
        }
      }
    );
    const newData = update(flavors, (isLemonade && ['dmb', 'dt'].includes(seller)) ? {
      all_flavors: {
        [categoryIndex]: {
          flavors: {
            [flavorIndex]: {
              [seller]: { $set: event.target.checked },
              updated_date: new Date()
            },
            [mangoFlavorIndex]: { [seller]: { $set: event.target.checked }, updated_date: new Date() },
            [strawberryFlavorIndex]: { [seller]: { $set: event.target.checked }, updated_date: new Date() },
          },
          newFlavorsList: {
            [foundIndex]: {
              list: {
                [foundItemId]: { [seller]: { $set: event.target.checked } },
                [mangoIndex]: { [seller]: { $set: event.target.checked } },
                [strawberryIndex]: { [seller]: { $set: event.target.checked } },
              },
            },
          },
        },
      },
    } : {
      all_flavors: {
        [categoryIndex]: {
          flavors: {
            [flavorIndex]: {
              [seller]: { $set: event.target.checked },
              updated_date: new Date()
            },
          },
          newFlavorsList: {
            [foundIndex]: {
              list: {
                [foundItemId]: { [seller]: { $set: event.target.checked } },
              },
            },
          },
        },
      },
    });
    setFlavors(newData);
    if (seller === 'favourite') {
      const req = {
        intStoreID: store?.intStoreID,
        fid,
        intProductTypeID: flavors?.all_flavors[categoryIndex]?.intProductTypeID,
        intFlavorID: flavorId,
        isFavourite: event.target.checked
      };
      updateFavourite(req, newData);
    }
    else {
      setIsDirty(true);
    }
  };

  const updateFavourite = async (req, newData) => {
    const response = await serviceapi?.updateStoreFavourite(req);
    enqueueSnackbar(response?.message ? "Favorite updated successfully" : "Failed to update favorite", {
      anchorOrigin: { vertical: "top", horizontal: "right" },
      variant: response?.message ? "success" : "error",
    })
    if (response?.message) {
      setTempFlavors(newData);
    }
  }

  const handleAllSellerCheck = (event, categoryIndex, flavorId) => {
    let allFlavors = { ...flavors };
    const updatedFlavors = flavors.all_flavors?.map((i, index) => {
      if (categoryIndex === index) {
        const mainFlavors = i?.flavors.map((j) => {
          const isLemonade = (lemonadesProductId === flavors?.all_flavors[categoryIndex]?.intProductTypeID) && flavorId === lemonadeId;
          if (flavorId === j?.intFlavorID) {
            let returnValue = {
              ...j,
              web: storeOptions?.web ? event.target.checked : false,
              oo: storeOptions?.oo ? event.target.checked : false,
              updated_date: new Date()
            };
            if (!j?.bitLTO && j?.bitIsOptional) {
              returnValue = {
                ...returnValue,
                dmb: storeOptions?.dmb ? event.target.checked : false,
                dt: storeOptions?.dt ? event.target.checked : false,
              }
            }
            return returnValue
          }
          else if ((isLemonade) && [mangoLemonadeId, strawberryLemonadeId].includes(j?.intFlavorID)) {
            let returnValue = null;
            if (!j?.bitLTO && j?.bitIsOptional) {
              returnValue = {
                ...j,
                dmb: storeOptions?.dmb ? event.target.checked : false,
                dt: storeOptions?.dt ? event.target.checked : false,
              }
            }
            return returnValue
          }

          return { ...j };
        });
        return { ...i, flavors: mainFlavors };
      }
      return { ...i };
    });
    allFlavors = { ...flavors, all_flavors: updatedFlavors };
    splitDataObject(allFlavors);
    setIsDirty(true);
  };

  const handleFlavorSearch = (event) => {
    if (event.target.value !== "") {
      setFlavorSearch(event.target.value);
    } else {
      setFlavorSearch("");
    }
  };

  const createGroups = (arr, numGroups) => {
    const perGroup = Math.ceil(arr?.length / numGroups);
    return (
      new Array(numGroups)
        .fill("")
        .map((_, i) => {
          return {
            start: i * perGroup + 1,
            end:
              (i + 1) * perGroup > arr?.length
                ? arr?.length
                : (i + 1) * perGroup,
            list: arr?.slice(i * perGroup, (i + 1) * perGroup),
          };
        })
    );
  };

  const changeTab = (event, newValue) => {
    setTab(newValue);
  };

  const clearFilters = () => {
    setFlavorSearch("");
  };

  const handleReset = () => {
    splitDataObject(tempFlavors);
    setIsDirty(false);
    setClearAll(false);
  };
  const handleClearAll = () => {
    setIsDirty(true);
    let allFlavors = { ...flavors };
    const updatedFlavors = flavors.all_flavors?.map((i,index) => {
      if(tab===0){
        const mainFlavors = i?.flavors.map((j) => {
          let activeRank=0
            if((j?.bitLTO || !j?.bitIsOptional)&& (j?.dmb || j?.dt)){
              activeRank=1
            }
            return {
              ...j,
              activeFlag: "0",
              web: false,
              dmb: (j?.bitLTO || !j?.bitIsOptional) ? j?.dmb: false,
              oo: false,
              dt: (j?.bitLTO || !j?.bitIsOptional) ? j?.dt: false,
              door_dash: false,
              uber_eats: false,
              grubhub: false,
              active_rank: activeRank,
            };
        });
        return { ...i, flavors: mainFlavors };
      } else if(tab===1) {
        const mainFlavors = i?.flavors.map((j) => {
          let activeRank=0
          if((j?.bitLTO || !j?.bitIsOptional) && (j?.dmb || j?.dt)){
            activeRank=1
          }
          return j.favourite ? {
            ...j,
            activeFlag: "0",
            web: false,
            dmb: (j?.bitLTO || !j?.bitIsOptional) ? j?.dmb: false,
            oo: false,
            dt: (j?.bitLTO || !j?.bitIsOptional) ? j?.dt: false,
            active_rank: activeRank,
          } : {...j};
        });
      return { ...i, flavors: mainFlavors };
      }else {
        if(index === tab-2){
              const mainFlavors = i?.flavors.map((j) => {
                let activeRank=0
                if((j?.bitLTO || !j?.bitIsOptional) && (j?.dmb || j?.dt)){
                  activeRank=1
                }
                return {
                  ...j,
                  activeFlag: "0",
                  web: false,
                  dmb: (j?.bitLTO || !j?.bitIsOptional) ? j?.dmb: false,
                  oo: false,
                  dt: (j?.bitLTO || !j?.bitIsOptional) ? j?.dt: false,
                  active_rank: activeRank,
                };
              });
              return { ...i, flavors: mainFlavors };
        }else{
          return { ...i}
        }
      }
    });
    allFlavors = { ...flavors, all_flavors: updatedFlavors };
    splitDataObject(allFlavors);
  };

  const viewFCAccess = () => {
    if (FCAccessRoles.indexOf(data?.profile?.role) !== -1) {
      return true;
    } else {
      return false;
    }
  };

  const handleFCClick=async()=>{
    setFCUser("")
    setStore("")
    setTempFlavors([]);
    setFlavors([]);
    setTab(0)
    setIsDirty(false);
    setLoading(true);
    await  getFCUserStores("all");
    setLoading(false)
  }

  const CoolAlertDialog=()=>{
    return (  <Dialog
      open={coolAlert}
      onClose={handleCoolAlert}
    >  
        <DialogContent>
        {submitLoading && seconds >= 5 && <Alert severity="error">This is taking longer than expected. Please wait or try again later.</Alert>}
          <div style={{paddingBottom:'1rem'}}>
             Do you want to send Cool Alerts now for all <b style={{color:'#55AAFF'}}>WEB</b> flavor updates? Press OK to Save and Send or Cancel to save without sending.
          </div>
          <div>
          <TextareaAutosize
            className=""
            style={{width:'100%'}}
            minRows={4}
            onChange={(e)=>setCoolAlertCustomMessage(e.target.value)}
            value={coolAlertCustomMessage}
            aria-label="Demo input"
            placeholder="Custom Cool Alerts Message"
          />
          </div>
          <div>
          <div style={{paddingBottom:'1rem'}}>
          <b style={{color:'#D41042'}}>Note</b>: If you are removing flavors or haven't selected any new WEB flavors, Cool Alerts won't be sent.
            </div> 
            <div>
          <Alert severity="info">Flavor changes on the shop's location website (<a style={{textDecoration:'underline'}} href="https://www.ritasice.com" target="_blank">www.ritasice.com</a>) and Cool Alerts emails may take up to 15 minutes to appear / send. </Alert>
          </div>
          </div>
      </DialogContent>
      <DialogActions>
        <Button disabled={submitLoading} onClick={() => handleSubmit(true)}>
          OK
        </Button>
        <Button
          disabled={submitLoading}
          onClick={() => handleSubmit()}
          autoFocus
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>)
  }
  let AllMainFlavors=flavors?.all_flavors
  if(store?.intRitasStoreID !== TEST_INTRITASSTOREID){
    AllMainFlavors=flavors?.all_flavors?.filter(i=> i?.intProductTypeID !== FLAVOR_DRIVEN_TREATS)
  }

  const flavorsData = flavorSearch?.length > 0 ? getSearchResults(AllMainFlavors, flavorSearch, 'flavors') : AllMainFlavors;
  const AllMainFlavorsData = flavorSearch?.length > 0 ? generateGroups(flavorsData) : AllMainFlavors;
  let last_updated_date="--"
  if(flavors?.last_updated_date){
    const date=new Date(flavors?.last_updated_date)
    last_updated_date = new Date(date).toLocaleString([], { year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit' })
  }

  return (
    <>
      <div>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
          open={submitLoading}
        >
          <CircularProgress color="inherit"  />
        </Backdrop>
        {coolAlert && CoolAlertDialog()}
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please save your changes before leaving the page.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleOK}>OK</Button>
            <Button onClick={handleClose} autoFocus>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      
        {!catering && <header className="pt-6 mt-16">
          <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
              {tab < 0 ? "Active" : "Flavor Portal"}
            </h1>

            <div className="flex justify-end ">
              <>
                {viewFCAccess() ? (<>
                  <Combobox
                    as="div"
                    value={fcuser}
                    onChange={handleFCUserChange}
                  >
                    <div className="relative mt-1">
                      <div className="absolute inset-y-0 left-0 flex items-center border-r border-gray-200 rounded-r-md px-2 focus:outline-none">
                        <ManageAccountsIcon
                          className="h-5 w-5 text-primary"
                          size="small"
                        />
                        
                      </div>

                      <Combobox.Input
                        className="w-full rounded-md border border-gray-300 bg-white py-2 px-10 shadow-sm focus:border-secondary focus:outline-none focus:ring-1 focus:ring-secondary sm:text-sm"
                        onChange={(event) => setQueryFC(event.target.value)}
                        placeholder="Select FC"
                        autoComplete="off"
                        onClick={() => handleFCClick()}
                        displayValue={(person) => {
                          if (person) {
                            return `${person?.fsm_name}`;
                          }
                        }}
                      />

                      <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                        <ChevronUpDownIcon
                          className="h-5 w-5 text-gray-400"
                          aria-hidden="true"
                        />
                      </Combobox.Button>
                      {filteredFCUsers.length > 0 && (
                        <Combobox.Options
                          style={{ zIndex: 1000 }}
                          className="absolute z-1000 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                        >
                          {filteredFCUsers.map((usrRole) => (
                            <Combobox.Option
                              key={usrRole.intStoreID}
                              value={usrRole}
                              className={({ active }) =>
                                classNames(
                                  "relative cursor-default select-none py-2 pl-3 pr-9",
                                  active
                                    ? "bg-secondary text-white"
                                    : "text-gray-900"
                                )
                              }
                            >
                              {({ active, selected }) => (
                                <>
                                  <span
                                    className={classNames(
                                      "block truncate",
                                      selected && "font-semibold"
                                    )}
                                  >
                                    {`${usrRole.fsm_name}`}
                                  </span>

                                  {selected && (
                                    <span
                                      className={classNames(
                                        "absolute inset-y-0 right-0 flex items-center pr-4",
                                        active ? "text-white" : "text-secondary"
                                      )}
                                    >
                                      <CheckIcon
                                        className="h-5 w-5"
                                        aria-hidden="true"
                                      />
                                    </span>
                                  )}
                                </>
                              )}
                            </Combobox.Option>
                          ))}
                        </Combobox.Options>
                      )}
                    </div>
                  </Combobox>
                  <StoreDropdown store={store} storeList={storeList} editStoreAccess={editStoreAccess} handleStoreChange={handleStoreChange} />
                  </>
                ) : null}
              </>
            
            </div>
          </div>
        </header>}
        <main>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading || flavorLoading}
          >
            <CircularProgress color="inherit"  />
          </Backdrop>
          <div className={`mx-auto max-w-7xl ${catering ? 'py-3' : 'py-8 sm:px-6 lg:px-8'}`}>
            <div className="px-4 sm:px-0">
              <div className="rounded-md bg-white shadow-md stickytop ">
                <div className="p-4 sm:flex sm:items-center sm:justify-between">
                  <div className="flex items-center gap-2 search-flavor-tour-selector">
                    <OutlinedInput
                      size="small"
                      autoComplete="off"
                      style={{
                        fontFamily:
                          "'Open Sans', Verdana, sans-serif, FontAwesome",
                      }}
                      sx={{ height: 32, paddingRight: 0, width: 260 }}
                      id="outlined-controlled"
                      placeholder="&#xF002; search"
                      name="flavorSearch"
                      value={flavorSearch}
                      onChange={handleFlavorSearch}
                      inputProps={{
                        style: {
                          color: "#000",
                          fontSize: "13px",
                        },
                      }}
                      endAdornment={
                        <InputAdornment>
                          <IconButton
                            onClick={clearFilters}
                            sx={{
                              visibility: flavorSearch ? "visible" : "hidden",
                            }}
                          >
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />               
                  </div>

                  <div className="mt-3 flex items-center flex-wrap sm:mt-0 sm:ml-4 gap-y-2">
                    {!catering && <p className="ml-3">Last updated on: <span className="font-bold uppercase">{last_updated_date}</span></p>}
                    <button
                      type="button"
                      onClick={handleClearAll}
                      className="clear-flavors-tour-selector ml-3 inline-flex items-center rounded-md border border-primary bg-white px-4 py-2 text-sm font-medium text-primary shadow-sm hover:bg-primary-light focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2"
                    >
                      <ClearAllIcon fontSize="small" />
                      <span className="ml-2">{tab===0 ? "Clear All": "Clear"}</span>
                    </button>
                    <button
                      type="button"
                      disabled={!isDirty}
                      onClick={handleReset}
                      className={`reset-flavors-tour-selector ml-3 inline-flex items-center rounded-md border border-primary bg-white px-4 py-2 text-sm font-medium text-primary shadow-sm hover:bg-primary-light focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 ${!isDirty && 'pointer-events-none opacity-40'}`}
                    >
                      <RestartAltOutlinedIcon fontSize="small" />
                      <span className="ml-2">Reset</span>
                    </button>
                    <button
                      type="button"
                      onClick={() => updateFlavors(last_updated_date)}
                      disabled={!flavors}
                      className={`update-flavors-tour-selector ml-3 inline-flex items-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 cursor-pointer`}
                    >
                      Update All
                    </button>
                  </div>
                </div>

                <div className="w-full h-full lg:w-5/5 border-b lg:border-b-0 lg:border-r pb-3 category-flavors-tour-selector">
                  {/* FLAVOR TABS */}
                  <Tabs
                    value={tab}
                    onChange={changeTab}
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="Todays Flavors"
                    TabIndicatorProps={{
                      style: {
                        backgroundColor: "#D97D54",
                      },
                    }}
                    classes={{ scroller: userOnboarding?.tourStatus?.flavorPortal ? "" : "!overflow-hidden" }}
                  >
                    {/* ACTIVE FLAVORS TAB DECLARATION */}
                    {flavors?.all_flavors && (
                      <Tab
                        className="text-primary text-right active-flavor-tour-selector"
                        key="active"
                        sx={{ alignSelf: "end" }}
                        label="Active"
                        id={"Active"}
                        tabIndex={0}
                        value={0}
                      ></Tab>
                    )}
                    {/* FAVORITES FLAVORS TAB DECLARATION*/}
                    {(flavors?.all_flavors && !catering) && (
                      <Tab
                        className="text-primary text-right favorites-tab-tour-selector"
                        key="favourites"
                        sx={{ alignSelf: "end" }}
                        label="Favorites"
                        id="Favorites"
                        tabIndex={1}
                        value={1}
                      />
                    )}

                    {/* CATEGORY SPECIFIC FLAVORS DECLARATION*/}
                    {AllMainFlavors?.map((category, i) => (
                      <Tab
                        className="text-primary text-right"
                        key={category.intProductTypeID?.toString()}
                        sx={{ alignSelf: "end" }}
                        tabIndex={i + 2}
                        value={i + 2}
                        id={`category-tab-${i+2}`}
                        label={`${category.product_type_name} (${
                          category?.flavors?.filter((flv) =>
                            flv.flavor_name?.toLowerCase()?.includes(flavorSearch?.toLowerCase())
                          ).length
                        })`}
                      />
                    ))}
                  </Tabs>
                </div>
              </div>
              <div className="flex flex-col lg:flex-row w-full items-start">
                <div className="w-full lg:w-5/5 bg-white-100">
                    {/* ACTIVE FLAVORS TAB DEFINITION*/}
                    <TabPanel value={tab} index={0}  key={"active"}>
                      <FavouritesList
                        catering={catering}
                        store={store}
                        flavors={flavorsData || []}
                        tCount={tCount}
                        tab={0}
                        storeOptions={storeOptions}
                        storeOptionsArray={storeOptionsArray}
                        handleSellerCheckFromChild={handleSellerCheckFromChild}
                        handleAllSellerCheck={handleAllSellerCheck}
                      />
                    </TabPanel>
                    {/* FAVORITES FLAVORS TAB DEFINITION*/}
                    {!catering && <TabPanel value={tab} index={1} key={"favorites"}>
                     <FavouritesList
                        catering={catering}
                        store={store}
                        flavors={flavorsData || []}
                        tCount={tCount}
                        tab={1}
                        storeOptions={storeOptions}
                        storeOptionsArray={storeOptionsArray}
                        handleSellerCheckFromChild={handleSellerCheckFromChild}
                        handleAllSellerCheck={handleAllSellerCheck}
                      />
                    </TabPanel>}
                    {/* STORE SPECIFIC FLAVORS TAB DEFINITION*/}
                  {
                    AllMainFlavorsData?.map((category, categoryIndex) => (
                      <TabPanel
                        key={category.intProductTypeID?.toString()}
                        value={tab}
                        index={categoryIndex + 2}
                      >
                        {flavorLoading ? (
                          <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                            <FlavorTabShimmer />
                            <FlavorTabShimmer />
                            <FlavorTabShimmer />
                            <FlavorTabShimmer />
                            <FlavorTabShimmer />
                            <FlavorTabShimmer />
                          </div>
                        ) : (
                          <div className="" key={category.intProductTypeID?.toString()}>
                            <StoreOptionsGrid catering={catering} />
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-5" >
                              {category?.newFlavorsList?.map(
                                (scategory, scategoryIndex) => (
                                  <FlavorCategoryItems
                                    catering={catering}
                                    categoryIndex={categoryIndex}
                                    category={category}
                                    scategory={scategory}
                                    scategoryIndex={scategoryIndex}
                                    storeOptionsArray={storeOptionsArray}
                                    storeOptions={storeOptions}
                                    handleAllSellerCheck={handleAllSellerCheck}
                                    handleSellerCheck={handleSellerCheck}
                                  />
                                )
                              )}
                            </div>
                          </div>
                        )}
                      </TabPanel>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Dialog
        open={openDialog}
        onClose={handleConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={'xs'}
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure, you want to submit without any flavor selection?"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleConfirmDialog}>Cancel</Button>
          <Button onClick={() => {
            setOpenDialog(false);
            handleSubmit(false, true);
          }} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={conflictItem?.show}
        onClose={handleRefreshFlavors}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={'xs'}
      >
        <DialogContent id="alert-dialog-title">
          {conflictItem?.message}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRefreshFlavors} autoFocus>Refresh</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FlavorsList;


